import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ArrowUp } from '@travel/icons/ui';
import { cx } from '@travel/utils';

import { getIsFindARoomBtnPresent } from 'store/providerInformation/selectors';

import { Translate } from 'core/translate';

import styles from './backToTopButton.module.scss';

export default function BackToTopButton() {
  const isFindARoomBtnPresent = useSelector(getIsFindARoomBtnPresent);
  const [isDisplayed, setIsDisplayed] = useState(false);

  useEffect(() => {
    function toggle() {
      if (window.scrollY > window.innerHeight) {
        if (!isDisplayed) {
          setIsDisplayed(true);
        }
      } else {
        if (isDisplayed) {
          setIsDisplayed(false);
        }
      }
    }
    window.addEventListener('scroll', toggle);

    return () => {
      window.removeEventListener('scroll', toggle);
    };
  }, [isDisplayed]);

  return (
    <button
      className={cx(
        styles.BackToTopButton,
        isFindARoomBtnPresent && styles.extraBottomSpacing,
        !isDisplayed && styles.hidden,
      )}
      onClick={() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }}
      data-testid="providerInformation-backToTopButton"
    >
      <ArrowUp color="white" className={styles.arrow}></ArrowUp>
      <Translate id="Traveler_Common.Top_Shortcut" className={styles.text} />
    </button>
  );
}
